module.exports = __webpack_public_path__ + "spartanconnect.png?7784998c6278a2a3d183376952e1bfbc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spartanconnect.png
// module id = 54
// module chunks = 0